<template>
  <div>
    <h1>Analytics
      <v-btn icon small @click="refreshData">
        <v-icon small>fa-sync</v-icon>
      </v-btn>
    </h1>

    <analytics-data-as-csv/>

    <analytics-filters/>

    <analytics-data/>
  </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import AnalyticsData from "../../components/analytics/AnalyticsData";
    import AnalyticsFilters from "../../components/analytics/AnalyticsFilters";
    import AnalyticsDataAsCsv from "../../components/analytics/AnalyticsDataAsCsv";

    export default {
        name: 'analytics-overview-page',
        components: {
            AnalyticsData,
            AnalyticsFilters,
            AnalyticsDataAsCsv,
        },
        data() {
            return {}
        },
        mounted() {
            this.analyticsFetch()
        },
        computed: {},
        methods: {
            ...mapActions({
                analyticsFetch: 'analyticsFetch',
            }),
            refreshData() {
                this.analyticsFetch()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/analytics/AnalyticsOverviewPage.vue